// Import the Hero component for displaying the page banner
import Hero from "../../frontend/components/Hero";
// Import an image to use as the background for the Hero section
import CalculatorsImag1 from "../../assets/images/checking-data-laptop.jpg";
// Import the calculator component for Mortgage Overpayment calculations
import MortgageOverpaymentCalculator from "../../frontend/components/calculators/OverpaymentCalculator";


// Main page component for the Mortgage Overpayment calculator
const MortgageOverpaymentCalculatorsPage = () => {
  return (
    <div>
      {/* Hero section with title and background image */}
      <Hero
        title="Overpayment"
        subtitle=""
        backgroundImage={CalculatorsImag1}
      />
      {/* Render the Mortgage Overpayment Calculator */}
      <MortgageOverpaymentCalculator />
      {/* Placeholder for additional content or layout, currently commented out */}
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

// Export the page component as default
export default MortgageOverpaymentCalculatorsPage;
